const fioc = require('../../fioc/fioc');

module.exports = {
    title: 'contractsView-yourActivityTitle',
    subtitle: 'contractsView-yourActivitySubTitle',
    description: 'profileFioc-formStepSubtitle',
    descriptionBold: true,
    order: 1,
    footer_text: '',
    position: 'first',
    components: [fioc()]
};
